var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON REGISTRATION"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5243 34.3061C50.6482 54.0641 21.9334 60.6775 15.5445 41.7219C15.3035 41.006 15.1037 40.2918 14.9508 39.5575C12.1066 25.9006 23.0278 22.3289 27.9913 21.2952C32.9548 20.2615 44.5223 19.7933 47.3685 33.46C47.4276 33.7439 47.4868 34.0279 47.5263 34.3158L47.5243 34.3061Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.6502 26.7107C28.632 26.9227 24.388 29.4001 25.232 33.4531C26.0761 37.5061 29.3328 37.8902 31.3594 37.4682C33.3859 37.0461 36.0085 34.3856 35.1624 30.3227C34.3163 26.2599 31.1656 26.3849 29.6384 26.7029L29.6502 26.7107Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.9079 51.2265C23.9079 51.2265 25.2813 40.4093 35.7021 41.0072C40.9115 41.3013 43.6069 47.5735 43.6069 47.5735",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.0811 26.3675L56.0992 59.7828L56.9973 66.4497L63.3184 64.2344L88.3004 30.8191C88.3004 30.8191 90.4017 27.7155 87.3879 25.5546C84.374 23.3937 81.0693 26.3598 81.0693 26.3598L81.0811 26.3675Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.1128 28.4424L85.6953 33.2207",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M70.2536 41.0332L63.3357 4.57795L2 16.9021L21.0242 98.5892L78.9684 87.1961L71.9426 53.4599",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.2004 64.3015L47.4573 59.6828",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M26.0354 73.1123L49.2922 68.4936",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.9602 82.354L64.9719 74.8708",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReg);
export default __webpack_public_path__ + "static/media/icon-reg.7a1ebff4b1075ff08bdb5bc2951dbbc2.svg";
export { ForwardRef as ReactComponent };